import React, { useRef } from "react";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { theme, Modal, Tooltip } from "antd";
import { PrinterOutlined, EditOutlined, ExclamationCircleOutlined, RedoOutlined} from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from "@fortawesome/free-solid-svg-icons";
import { URL_REPORT, URL_TRUCK } from "../../constants/urls";
import * as _ from "lodash";
import {
  dateToHumanString,
  formatComma,
  getLabResultColor,
  timeToString,
  toFixed,
} from "../../frameworks/Util";
import ReceivingLatexModal from "../receiving-latex/ReceivingLatexModal";
import { DELETE, POST } from "../../frameworks/HttpClient";
import ErrorMessages from "../../common/ErrorMessages";
import ReceivingWeightLogModal from "./ReceivingWeightLogModal";
import ReceivingWeightPopover from "./ReceivingWeightPopover";
import { TRUCK_ACTION, USER_GROUP } from "../../constants/string";
import CustomDeleteConfirmButton from "../../common/CustomDeleteConfirmButton";
import SummaryWeightLatex from "../common/SummaryWeightLatex";
import { useUserContext } from "../../hooks/UserSettingProvider";
import { PRIMARY_COLOR } from "../../constants/color";
import ReportButton from "../../components/common/ReportButton";

const ReceivingLatexList = React.forwardRef((props, ref) => {
  const { user } = useUserContext();
  const hasPermission = (target) => (user && user.groups &&  user.groups.length > 0 ? (user.groups.find((group) => group === target) ? true : false) : true)
  const { total } = props;
  const [openReceivingModal, setOpenReceivingModal] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [targetOutWeightLog, setTargetOutWeightLog] = React.useState(null);
  const [targetInWeightLog, setTargetInWeightLog] = React.useState(null);
  const [target, setTarget] = React.useState(null);
  const summaryRef = React.useRef(null);
  const tableRef = React.useRef(null);
  const {
    token: { colorWarning, colorError, colorSuccess },
  } = theme.useToken();

  React.useImperativeHandle(ref, () => ({
    fetchTable: () => refreshData(),
  }));

  const refreshData = async () => {
    if (tableRef.current) await tableRef.current.fetchWithoutResetPage();
    if (summaryRef.current) await summaryRef.current.fetch();
    if (props.fetchHasLab) await props.fetchHasLab();
  };

  const confirm = (value) => {
    Modal.confirm({
      title: <div style={{ height : 30, fontSize: 18 }}>ยืนยันรับรถส่งยาง</div>,
      icon: <ExclamationCircleOutlined />,
      content: <div style={{ height : 35, fontSize: 16, marginBottom : 10 }}>ยืนยันการรับรถส่งยางหรือไม่ ?</div>,
      maskClosable: true,
      footer: <div style={{ float : 'right'}}>
        <ColorButton
          style={{ margin : 5}}
          onClick={async() => {
            await refreshData();
            await Modal.destroyAll();
          }}
        >
          ปิด
        </ColorButton>
        <ColorButton
          type="primary"
          override={colorError}
          style={{ margin : 5}}
          onClick={async() => {
            await handleReject(value);
            await refreshData();
            await Modal.destroyAll();
          }}
        >
          ปฏิเสธ
        </ColorButton>
        <ColorButton
          type="primary"
          override={colorSuccess}
          style={{ margin : 5}}
          onClick={async() => {
            await handleApprove(value);
            await refreshData();
            await Modal.destroyAll();
          }}
        >
          ยืนยัน
        </ColorButton>
      </div>,
    });
  };

  const confirmRedo = (title, value) => {
    Modal.confirm({
      title: `ย้อนกลับสถานะ - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color : PRIMARY_COLOR}} />,
      content: 'คุณต้องการย้อนกลับสถานะรับรถหรือไม่ ?',
      okText: 'ยืนยัน',
      cancelText: 'ยกเลิก',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : PRIMARY_COLOR}},
      onOk:async() => {
        await handleRedoTruckStatus(value)
      },
      onConfirm: () => refreshData()
    });
  };

  const handleRedoTruckStatus = async (id) => {
    try {
      await POST(`${URL_TRUCK.TRUCK_TRANSACTION}${id}/revert/`)
      refreshData();
    } catch (error) {
      setErrorMessage(error.errorMessage)
    }
  }

  const handleApprove = async (id) => {
    try {
      await POST(
        `${URL_TRUCK.TRUCK_TRANSACTION}${id}/${TRUCK_ACTION.APPROVE}/`
      );
      refreshData();
    } catch (error) {
      setErrorMessage(error.errorMessage);
    }
  };

  const handleReject = async (id) => {
    try {
      await POST(`${URL_TRUCK.TRUCK_TRANSACTION}${id}/${TRUCK_ACTION.REJECT}/`);
      refreshData();
    } catch (error) {
      setErrorMessage(error.errorMessage);
    }
  };

  const handleDelete = async (id) => {
    setErrorMessage(null);
    try {
      await DELETE(`${URL_TRUCK.TRUCK_TRANSACTION}${id}/`);
      refreshData();
    } catch (error) {
      setErrorMessage(error.setErrorMessage);
    }
  };


  const columns = [
    {
      title: "Action",
      dataIndex: "id",
      // hidden: total,
      key: "Action",
      render: (value, original) => {
        return (
          <div
            style={{ textAlign: "center" }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {_.get(original, "is_lab_complete", false) === false &&
              _.get(original, "is_approved", null) === null && (
              <CustomDeleteConfirmButton
                title={`ยืนยันลบบัตร ${original.code} หรือไม่`}
                content={"ยืนยันลบบัตรชั่งหรือไม่ ?"}
                onOk={ async() => {
                  await handleDelete(original.id)
                  refreshData();
                }}
                onConfirm={() => refreshData()}
              />
              )}
            {_.get(original, "is_lab_complete", false) &&
              _.get(original, "is_approved", null) === null && (
                <Tooltip triger='hover' title={"ยืนยันรับรถ"}>
                  <ColorButton
                    type="primary"
                    override={"#34C759"}
                    style={{ margin: 5 }}
                    icon={<FontAwesomeIcon icon={faTruck} />}
                    onClick={() => confirm(value)}
                  />
                </Tooltip>
              )}
            { (_.get(original, "is_approved", null) === true || _.get(original, "is_approved", null) === null) &&
              <ReportButton
                url={`${URL_REPORT.LAB_REQUEST_ORDER}${original.lab_order}/?size=slip`} 
                tooltip={'พิมพ์ฉลากน้ำยางสด'}
                sentError={(e) => setErrorMessage(e)}
              />
            }
            {(_.get(original, "is_approved", null) === true || _.get(original, "is_approved", null) === null) && _.get(original, "is_complete", true) === false &&
              <Tooltip triger='hover' title={"แก้ไขข้อมูล"}>
                <ColorButton
                  type="primary"
                  override={colorWarning}
                  icon={<EditOutlined />}
                  style={{ margin : 5}}
                  onClick={(value) => {
                    setOpenReceivingModal(true);
                    setTarget(original);
                  }}
                />
              </Tooltip>
            }
            {hasPermission(USER_GROUP.WEIGHT_MANAGER) && (_.get(original, "is_approved", null) === true || _.get(original, "is_approved", null) === false) && (_.get(original, "pond_input", false) ? false : true) &&
              <Tooltip triger='hover' title={"ย้อนกลับสถานะ"}>
                <ColorButton
                  type="primary"
                  override={PRIMARY_COLOR}
                  style={{ margin: 5 }}
                  icon={<RedoOutlined />}
                  onClick={() => confirmRedo(original.code, original.id)}
                />
              </Tooltip>
            }
          </div>
        );
      },
    },
    {
      title: "ลำดับ",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "เที่ยวที่",
      dataIndex: "round_trip",
      key: "round_trip",
    },
    {
      title: "เลขที่บัตร",
      dataIndex: "code",
      key: "code",
      searcher: true,
    },
    {
      title: "รหัสผู้ขาย",
      dataIndex: "supplier_code",
      key: "supplier_code",
      searcher: true,
    },
    {
      title: "ทะเบียนรถ",
      dataIndex: "vehicle_license_plate",
      key: "vehicle_license_plate",
      searcher: true,
    },
    {
      title: "วันที่",
      dataIndex: "created",
      key: "date",
      width: 10,
      render : (value) => dateToHumanString(value),
      searcher:  true,
      dateRangeSearcher: true,
    },
    {
      title: "เข้า",
      children: [
        {
          title: "เวลา",
          dataIndex: "in_datetime",
          key: "in_datetime",
          render: (value) => {
            return (
              <center>
                {/* <div>{value ? dateToHumanString(value) : "-"}</div> */}
                <div>{value ? timeToString(value) : "-"}</div>
              </center>
            );
          },
        },
        {
          title: "น้ำหนัก",
          dataIndex: "in_weight",
          key: "in_weight",
          render: (value, original) => (
            <>
              {value ? (
                <Tooltip triger='hover' title={"ประวัติน้ำหนักเข้า"}>
                  <a onClick={() => setTargetInWeightLog({ id: original.id })}>
                    {formatComma(toFixed(value, 0))}
                  </a>
                </Tooltip>
              ) : (
                "-"
              )}
              <ReceivingWeightPopover
                target={original.id}
                direction={"in"}
                onUpdate={() => refreshData()}
              >
                <Tooltip triger='hover' title={"กรอกน้ำหนัก"}>
                    <EditOutlined
                      style={{ color: colorWarning, marginLeft: 5 }}
                    />
                </Tooltip>
              </ReceivingWeightPopover>
            </>
          ),
        },
      ],
    },
    {
      title: "ออก",
      children: [
        {
          title: "เวลา",
          dataIndex: "out_datetime",
          key: "out_datetime",
          render: (value, original) => {
            return (
              <center>
                {/* <div>{value ? dateToHumanString(value) : "-"}</div> */}
                <div>{value ? timeToString(value) : "-"}</div>
              </center>
            );
          },
        },
        {
          title: "น้ำหนัก",
          dataIndex: "out_weight",
          key: "out_weight",
          render: (value, original) => (
            <>
              {value ? (
                <Tooltip triger='hover' title={"ประวัติน้ำหนักออก"}>
                  <a onClick={() => setTargetOutWeightLog({ id: original.id })}>
                  {formatComma(toFixed(value, 0))}
                  </a>
                </Tooltip>
              ) : (
                "-"
              )}
              <ReceivingWeightPopover
                target={original.id}
                direction={"out"}
                onUpdate={() => refreshData()}
              >
                <Tooltip triger='hover' title={"กรอกน้ำหนัก"}>
                  <EditOutlined
                    style={{ color: colorWarning, marginLeft: 5 }}
                  />
                </Tooltip>
              </ReceivingWeightPopover>
            </>
          ),
        },
      ],
    },
    {
      title: 'น้ำหนักสุทธิ',
      dataIndex: 'net_weight',
      key: 'net_weight',
      render: (value) => value ? <center>{formatComma(toFixed(value, 0))}</center>: "-"
    },
    {
      title: "Lot น้ำยางสด",
      dataIndex: "pond_input",
      key: "pond_input",
      hidden: total ? false : true,
      render: (value, original) =>
        original.pond_input ? (
          <>
            <div>ล็อต : {_.get(original, "lot_no_input", "-")}</div>
            <div>บ่อ : {_.get(original, "pond_input", "-")}</div>
            <div>กระบะ : {_.get(original, "tray_input", "-")}</div>
          </>
        ) : (
          "-"
        ),
    },
    {
      title: "ผลแล็บ",
      dataIndex: "",
      key: "lab_results",
      render: (value, original) => {
        return _.get(original, "lab_results", "-").map((item) => {
          return (
            <div style={{ color: getLabResultColor(_.get(item, 'status', null)) }}>
              <Tooltip title={item.note}>{item.chemical} : {toFixed(item.amount, 3)}</Tooltip>
            </div>
          );
        });
      },
    },
    {
      title: "สถานะ",
      dataIndex: "is_approved",
      key: "is_approved",
      hidden: total ? false : true,
      width: 70,
      render : (value) => <center>{value === null ? 'รอรับ' : value === true ? 'รับแล้ว' : 'ปฏิเสธ'}</center>
    },

  ];

  React.useEffect(() => {
    const interval = setInterval(() => {
      refreshData();
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <ErrorMessages message={errorMessage} />
      {total == false && <ColorButton
        type="primary"
        override={colorSuccess}
        style={{ marginBottom: 10, display: "flex", float: "right" }}
        onClick={() => {
          setTarget("add");
          setOpenReceivingModal(true);
        }}
      >
        + เพิ่มรถเข้า
      </ColorButton>}
      <SummaryWeightLatex ref={summaryRef} showHasLab={true}/>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={"small"}
        url={URL_TRUCK.TRUCK_TRANSACTION}
        params={{ status: total ? "all" : "progressing" }}
        rowClassName={(record) => {
          if (record.is_approved && !record.out_weight) {
            return "table-row-green";
          } else if (record.is_lab_complete && _.get(record, "is_approved", null) === null){
            return "table-row-red";
          }
        }}
      />

      <ReceivingLatexModal
        open={openReceivingModal}
        onClose={() => {
          setOpenReceivingModal(false);
        }}
        onUpdate={() => {
          setOpenReceivingModal(false);
          refreshData();
        }}
        target={target}
      />

      <ReceivingWeightLogModal
        open={targetInWeightLog ? true : false}
        target={targetInWeightLog}
        onClose={() => setTargetInWeightLog(null)}
        direction={"in"}
      />

      <ReceivingWeightLogModal
        open={targetOutWeightLog ? true : false}
        target={targetOutWeightLog}
        onClose={() => setTargetOutWeightLog(null)}
        direction={"out"}
      />
    </div>
  );
});

export default ReceivingLatexList;
